import { defineStore } from 'pinia'
import { logStore } from '@/logging/logStore'
import type { LogEntry } from '@/logging/types'

export interface LogState {
  isEnabled: boolean
  logs: LogEntry[]
}

export const useLogStore = defineStore('log', {
  state: (): LogState => ({
    isEnabled: logStore.diagnosticMode,
    logs: []
  }),

  actions: {
    async setEnabled(enabled: boolean) {
      logStore.setDiagnosticMode(enabled)
      this.isEnabled = enabled
    },

    async loadLogs(): Promise<LogEntry[]> {
      const storeLogs = await logStore.getAllLogs()
      const logs = Array.isArray(storeLogs) ? storeLogs : []
      this.logs = logs
      return logs
    },

    async clearLogs(): Promise<void> {
      await logStore.clearLogs()
      this.logs = []
    }
  }
})